import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useAppScopeStore } from '@frontend/scope';
import { useSchedulingLocationInfo } from '../use-scheduling-location-info';

export const useIsRequestTabEnabled = ({ locationIds: locationIdsProp }: { locationIds?: string[] } = {}) => {
  const { getOnlineSchedulingReadyLocationIds } = useSchedulingLocationInfo();
  const { selectedLocationIds } = useAppScopeStore();
  const locationIds = locationIdsProp ?? selectedLocationIds;
  const { enabledLocationIds: preferenceBasedRequestEnabledLocationIds } =
    SchedulerV3.Helpers.useGetPreferenceBasedRequestFeatureFlagDetails();

  const onlineSchedulingReadyLocationIds = getOnlineSchedulingReadyLocationIds();
  const onlineSchedulingEnabledLocationIds = locationIds.filter((locationId) =>
    onlineSchedulingReadyLocationIds.includes(locationId)
  );
  const enabledLocationIds = Array.from(
    new Set([...onlineSchedulingEnabledLocationIds, ...preferenceBasedRequestEnabledLocationIds])
  );
  const isRequestTabEnabled = enabledLocationIds.length > 0;

  return { isRequestTabEnabled, enabledLocationIds };
};
